import React from 'react';
import { ThemeProvider } from '@mui/material/styles';

import { appTheme } from './light';
import { DarkAppTheme } from './dark';
import { ThemeRevertWidget, ThemeVersionProvider, useThemeVersionValue } from './themeVersion';

/**
 * Chooses the active MUI theme based on the `can_view_dark_theme` feature flag.
 * Permitted users get the dark theme by default and can revert via the floating
 * widget; everyone else gets the original. Must render under the Redux Provider.
 */
export default function ThemedApp({ children }: { children: React.ReactNode }) {
  const themeVersion = useThemeVersionValue();
  return (
    <ThemeVersionProvider value={themeVersion}>
      <ThemeProvider theme={themeVersion.useDark ? DarkAppTheme : appTheme}>
        {children}
        <ThemeRevertWidget />
      </ThemeProvider>
    </ThemeVersionProvider>
  );
}
